import React from 'react';
import { Tabs } from 'freemium-ui';

import Icons from 'components/icons';

import { ACTIVE_OPTIONS as OPTIONS } from '../../constants';
import QuestionType from './question';
import { RATING_TABS } from '../../constants';

export type StepProps = {
  block: any;
  setOpen: Function;
  surveyForm: any;
  blocks: any;
  setSurveyForm: Function;
  open: boolean;
  thankYouMessage?: boolean;
  blockIndex: number;
};

const Block = ({
  block,
  setOpen,
  surveyForm,
  setSurveyForm,
  thankYouMessage,
  open,
  blocks,
  blockIndex,
}: StepProps) => {
  const [activeRatingTab, setActiveRatingTab] = React.useState(
    RATING_TABS[0].id,
  );
  const blockQuestionIndex = surveyForm?.question_details?.questions?.findIndex(
    (question: any) => block?.primary_question_name === question.name,
  );

  const activeQuestion = block?.is_based_on_rating
    ? RATING_TABS.findIndex((s) => s.id === activeRatingTab)
    : 0;

  const currentOption = OPTIONS.find((option) => option.id === block?.type);

  return (
    <section key={`block-${block?.name}`}>
      <div
        className={`section ${open ? 'open' : ''}`}
        onClick={() => setOpen(blockIndex)}
      >
        <div className="section-header">
          <div className="section-title">
            {!open && !thankYouMessage && block?.type !== 'RANGE' && (
              <>
                <Icons
                  size="18"
                  viewBox={currentOption?.viewBox || '0 0 18 18'}
                  fill="none"
                  glyph={currentOption?.icon}
                />
                <span className="section-type">
                  {/* {block?.type !== 'RANGE' && <>&nbsp;-&nbsp;</>} */}
                  {currentOption?.label || ''}
                </span>
              </>
            )}

            <div>{block?.title}</div>
          </div>
        </div>

        {open && block?.is_based_on_rating && (
          <div className="section-question">
            <div className="rating-tabs">
              <Tabs
                value={activeRatingTab}
                onChange={(e: any, v: any) => {
                  e.preventDefault();
                  e.stopPropagation();
                  setActiveRatingTab(v.id);
                }}
                options={RATING_TABS}
              />
            </div>
          </div>
        )}
        <div key={`question-${activeQuestion}`}>
          <QuestionType
            setSurveyForm={setSurveyForm}
            surveyForm={surveyForm}
            block={block}
            blockQuestionIndex={blockQuestionIndex}
            blocks={blocks}
            open={open}
            thankYouMessage={thankYouMessage}
            activeQuestion={activeQuestion}
            readOnly={true}
            disabled={true}
          />
        </div>
      </div>
    </section>
  );
};

export default Block;
